import React from 'react';
import { connect } from 'react-redux';
import { setConciergeComments } from '../../../Redux/ActionCreator';

class CommentsBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.getInitalValue(),
            lengthRemaining: this.props.vRemainingLength,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
    }

    getInitalValue() {
        return this.props.vmiscService ? this.props.vmiscService : this.props.initialText;
    }

    handleChange(event) {
        const filteredValues = [...event.target.value].filter((x) => x.match(/[^{};<>]/) !== null).join('');
        this.setState({
            value: filteredValues,
            lengthRemaining: 150 - filteredValues.length,
        });
        this.props.setConciergeComments(filteredValues.trim());
    }

    handleOnFocus(event) {
        this.state.value === this.props.initialText ? this.setState({ value: '', lengthRemaining: 150 }) : null;
    }

    handleOnBlur(event) {
        this.props.setConciergeComments(event.target.value.trim());
        event.target.value.length === 0
            ? this.setState({ value: this.props.initialText, lengthRemaining: 150 })
            : this.setState({
                  value: event.target.value,
                  lengthRemaining: 150 - event.target.value.length,
              });
    }

    render() {
        return (
            <div className="submit-appointment-comments">
                <label className="submit-appointment-label">
                    {this.props.label}
                    <textarea
                        id="txtPpdComments"
                        className="stat-input-field submit-appointment-comments-box"
                        placeholder={this.state.value}
                        maxLength="150"
                        type="text"
                        value={this.state.value}
                        onChange={this.handleChange}
                        onFocus={this.handleOnFocus}
                        onBlur={this.handleOnBlur}
                        data-dtm="service needs"
                    />
                </label>
                <div className="submit-appointment-length-remaining">
                    {this.state.lengthRemaining} {`${this.props.vTranslations.CHARACTERS_REMAINING.toLowerCase()}...`}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    vmiscService: state.appointmentReducer.conciergeComments,
    vbooleanVal: state.ossAppGlobals.booleanVal,
    vRemainingLength: state.appointmentReducer.remainingCharacters,
    vTranslations: state.countryOptionsReducer.translations,
});

export default connect(mapStateToProps, { setConciergeComments })(CommentsBox);
